<template>
  <v-menu 
      v-model="showServiceStatusWindow"      
      :close-on-content-click="false"
      rounded="large"
      offset-y
      absolute
      :position-x="positionX"
      :position-y="positionY"
    >
    <v-card>
      <v-list>
        <v-list-item v-for="service in Object.keys(this.serviceStatus)" :key="service" class="d-flex align-center">
          <v-list-item-icon>
            <v-icon :color="serviceStatusColor(service)">mdi-circle</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t('serviceStatus.' + service) }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn color="blue darken-1" text @click="restartService(service)">{{ $t('serviceStatus.restart')}}</v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { notifyError, notifySuccess } from '../../services/notifications';
export default {
  name: 'ServiceStatusWindow',
  async mounted() {
    try {
      Object.keys(this.serviceStatus).forEach(service => this.getStatus(service));

      this.intervalId = setInterval(
        () => Object.keys(this.serviceStatus).forEach(service => this.getStatus(service)), 
        20000); // получаем статусы каждые 20 секунд
    } catch (error) {
      console.error('Error initializing service status window:', error);
    }
  },
  beforeDestroy() {
    // останавливаем таймер при уничтожении компонента, чтобы не было утечек памяти
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  data() {
    const services = this.$store.getters.SERVICES;
    const serviceStatus = {};
    services.forEach((service) => serviceStatus[service] = '');
    
    return {
      showServiceStatusWindow: true,
      serviceStatus: serviceStatus,
    };
  },
  methods: {
    async restartService(service) {
      try {
        await this.$axios.servicesApi.restart(service);
        notifySuccess('', this.$t('serviceStatus.success'));
        this.$emit('hideWindow');
      } catch (error) {
        notifyError(this.$t('serviceStatus.error'));
      }
    },
    async getStatus(service) {
      try {
        const response = await this.$axios.servicesApi.getStatus(service);
        if (response && response.data) {
          this.$set(this.serviceStatus, service, response.data.status);
        }
      } catch (error) {
        console.error(`Error getting status for ${service}:`, error);
        this.$set(this.serviceStatus, service, 'Error');
      }
    },
    serviceStatusColor(service) {
      if (!this.serviceStatus[service]) return 'grey';

      return this.serviceStatus[service] === 'Running' ? 'green' : 'red';
    },
  },
  computed: {
    positionX() {
      return window.innerWidth - 20 - 400; // 20px отступ справа, 400px ширина модального окна
    },
    positionY() {
      return 64; // высота appbar
    }
  },
  watch: {
    showServiceStatusWindow(value) {
      // нужно для кейса, когда окно закрывается не повторным нажатием на кнопку,
      // а при открытии другой модалки (например, настроек)
      if (!value) {
        this.$emit('hideWindow');
      }
    }
  }
};
</script>

<style>
  .btn {
    pointer-events: all;
  }
</style>
